import { request } from './index'
import $store from '@/store/index'
import { resolveTagMatchMode } from '@/assets/js/handleTag'

// const protocol = window.location.protocol

export const updateRelation = data => {
  return request({
    url: '/media-hub/project/updateProjectRelation',
    method: 'POST',
    data,
    notifyTitle: 'Update Relation'
  })
}

// export const destinationList = data => {
//   return request({
//     url: `${$store.state.initConfig.mxServiceUrl}/mx-service/media/list`,
//     method: 'POST',
//     data
//   })
// }

// /media-hub/media/list
export const destinationList = data => {
  return request({
    url: '/media-hub/destination/list',
    method: 'POST',
    // 随组设置 tagFilterMode 发送多 tag 匹配模式（MH-3459）：axios 层统一注入，所有调用宿主无感生效 [Claude Code]
    data: { ...data, tagMatchMode: resolveTagMatchMode($store.state.adminInfo.tagFilterMode) },
    notifyTitle: 'Load Destinations'
  })
}

export const destinaMixedOutputList = data => {
  return request({
    url: '/media-hub/mixed/output/object/list',
    method: 'POST',
    // 同 destinationList：聚合行按外层对象或任一 destination 命中同模式匹配（MH-3459）[Claude Code]
    data: { ...data, tagMatchMode: resolveTagMatchMode($store.state.adminInfo.tagFilterMode) },
    notifyTitle: 'Load Mixed Outputs'
  })
}

// /media-hub/destination/startLive
export const startLive = data => {
  return request({
    url: '/media-hub/destination/startLive',
    method: 'POST',
    // wsNotifyKey 复合格式 `<action>_<destinationObjectId>`，WS 端解析 key 拿到 objectId [Claude Code]
    data: { ...data, wsNotifyKey: `destinationStartLive_${data.destinationObjectId}` },
    notifyTitle: 'Start Live'
  })
}

// /media-hub/destination/startLive
export const switchLive = data => {
  return request({
    url: '/media-hub/destination/switch',
    method: 'POST',
    // wsNotifyKey 复合格式 `<action>_<destinationObjectId>`，WS 端解析 key 拿到 objectId [Claude Code]
    data: { ...data, wsNotifyKey: `destinationSwitchLive_${data.destinationObjectId}` },
    notifyTitle: 'Switch Live'
  })
}

export const stopLive = data => {
  return request({
    url: '/media-hub/destination/stopLive',
    method: 'POST',
    // wsNotifyKey 复合格式 `<action>_<destinationObjectId>`，WS 端解析 key 拿到 objectId [Claude Code]
    data: { ...data, wsNotifyKey: `destinationStopLive_${data.destinationObjectId}` },
    notifyTitle: 'Stop Live'
  })
}

export const destTags = data => {
  return request({
    url: '/media-hub/destination/getTags',
    method: 'GET',
    data,
    notifyTitle: 'Load Tags'
  })
}

//
export const getSwitcherInfoByDestinationObjectId = data => {
  return request({
    url: `${$store.state.initConfig.mxServiceUrl}/mx-service/common/getSwitcherInfoByDestinationObjectId`,
    method: 'GET',
    params: data,
    notifyTitle: 'Load Switcher Info'
  })
}

export const getDestinationInfo = data => {
  return request({
    url: '/media-hub/destination/get',
    method: 'GET',
    params: data,
    notifyTitle: 'Load Destination'
  })
}

/**
 * 更新 destination 对象属性（如 audio remapping 声道配置） [Claude Code]
 *
 * @todo Apifox 核对：以下 method / 入参 / 响应为按本仓库对象模型（attributes: [{attrName, attrValue}]）的推断，
 *       Apifox 为登录态页面无法读取真值，确认后请据实修正 [Claude Code]
 *
 * @param {Object} data - 请求参数
 * @param {string} data.objectId - destination 对象 ID（必填）
 * @param {Array<Object>} data.attributes - 待更新的属性列表
 * @param {string} data.attributes[].attrName - 属性名，如 'audioRemapping'
 * @param {string[]} data.attributes[].attrValue - 属性值数组
 *
 * @example
 * updateObjectAttr({
 *   objectId: '1417526727718080512',
 *   attributes: [
 *     { attrName: 'inputChannelCount', attrValue: ['8'] },
 *     { attrName: 'outputChannelCount', attrValue: ['8'] }
 *   ]
 * }).then(res => {
 *   if (res.errorCode === '0x0') console.log('updated')
 * })
 *
 * @returns {Promise}
 * 成功响应示例：
 * {
 *   errorCode: '0x0',                       // 0x0 = success
 *   errorInfo: 'success',                   // error message
 *   result: {
 *     objectId: '1417526727718080512',      // destination 对象 ID
 *     attributes: [{                        // 更新后的属性列表
 *       attrName: 'inputChannelCount',      // 属性名
 *       attrValue: ['8']                    // 属性值数组
 *     }]
 *   }
 * }
 *
 * 失败响应示例：
 * { errorCode: '0x1', errorInfo: 'error message' }
 */
export const updateObjectAttr = data => {
  return request({
    url: `${$store.state.initConfig.mxServiceUrl}/mx-service/destination/updateObjectAttr?objectId=${data.objectId}`,
    method: 'POST',
    data: data.attributes,
    notifyTitle: 'Update Destination Attr'
  })
}

// /media-hub/{project|destination}/preview/change
export const outputPreview = data => {
  return request({
    url: '/media-hub/destination/preview/change',
    method: 'GET',
    params: data,
    notifyTitle: 'Preview'
  })
}

export const createFolder = data => {
  return request({
    url: '/media-hub/destination/folder/create',
    method: 'POST',
    data,
    notifyTitle: 'Create Folder'
  })
}

export const getFolderList = data => {
  return request({
    url: '/media-hub/destination/folder/list',
    method: 'POST',
    data,
    notifyTitle: 'Load Folders'
  })
}
